export { GuestRegistryProvider as default } from './GuestRegistry';
